<template>
  <mdb-container class="gp-has-header">

    <data-table v-show="!showEditor" ref="storeList" :add-handler="create"
                :click-handler="editLink"
                :columns="columns"
                add-label="New Link"
                data-source="/legacyLink/list"
                page-title="Legacy Links"
                show-add-button/>

    <div v-if="showEditor" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-input id="urlName" v-model="currentLink.urlName" label="URL Path"/>
      <mdb-input id="redirect" v-model="currentLink.redirect" label="Redirect To"/>
      <mdb-btn :disabled="!currentLink.urlName || !currentLink.redirect"
               @click="save">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>
      <mdb-btn @click="deleteModal=true" icon="trash" color="danger">
        Delete
      </mdb-btn>
    </div>
    <yes-no-modal v-if="deleteModal" @yes="deleteLink" @no="deleteModal=false"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import dataTable from "../common/DataTable";
import Vue from "vue";
import yesNoModal from "../common/YesNoModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';
import YesNoModal from "../common/YesNoModal";

export default {
  name: "system-pages-admin",
  display: "Admin System Pages",
  order: 1,
  components: {
    YesNoModal,
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    dataTable,
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {

  },
  data() {
    return {
      links: [],
      currentLink: {
        id: null, redirect: "", urlName: ""
      },
      showEditor: false,
      showViewer: false,
      deleteModal: false,
      columns: [
        {label: "URL", field: "urlName"},
        {label: "Redirects To", field: "redirect"}
      ]
    }
  },
  methods: {
    create: function () {
      this.currentLink = {
        urlName: "", redirect: "", id:null
      }
      this.showEditor = true
      Vue.nextTick().then(() => {
        let el = document.getElementById("urlName")
        if (el) el.focus()
        else console.error("Couldn't find urlName to focus")
      })

    },
    deleteLink: function () {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/legacyLink/details/" +  this.currentLink.id).then(
        (details) => {
          this.showList()
          this.$notify.success({message: "Link deleted successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/legacyLink/details", this.currentLink).then(
        (details) => {
          if (!this.currentLink.id) {
            this.currentLink = details.data
          }
          this.$notify.success({message: "Link saved successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editLink: function (link) {
      this.currentLink = link
      this.showEditor = true
    },
    showList: function () {
      this.showEditor = false
      this.$store.dispatch("setDataTableReload", true)
    }
  }

}
;
</script>
